import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

type AppShellProps = {
  banner: ReactNode;
  children: ReactNode;
  onHeaderNav?: (target: "home" | "villages" | "interviewees") => void;
  activeNav?: "home" | "villages" | "interviewees";
};

export function AppShell({ banner, children, onHeaderNav, activeNav }: AppShellProps) {
  const hasHero = Boolean(banner);
  return (
    <div className={`app-root${hasHero ? " app-root--hero" : ""}`}>
      <Header onNavigate={onHeaderNav} isHero={hasHero} activeNav={activeNav} />
      <main className="app-shell">
        <div className="app-shell__content">
          {hasHero && <div className="hero-frame">{banner}</div>}
          <div className="app-shell__body">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
